export function maptilerKey() {
  const meta = document.querySelector('meta[name="maptiler-key"]')
  return meta?.content || ''
}

export function maptilerTileUrl(style = 'base-v4') {
  const key = maptilerKey()
  return `https://api.maptiler.com/maps/${style}/{z}/{x}/{y}.png?key=${encodeURIComponent(key)}`
}

export const maptilerAttribution =
  '<a href="https://www.maptiler.com/copyright/" target="_blank" rel="noopener">&copy; MapTiler</a> ' +
  '<a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">&copy; OpenStreetMap contributors</a>'
